import { Empty, Tabs } from 'antd';
import { useEffect, useState } from 'react';
import Api from '../../../api/Api';
import { IDatasetMetadata } from '../../../types/metadata';
import { Loading } from '../../common/Loading/Loading';
import styles from './Metadata.module.scss';
import MetadataList from './MetadataList';

const initialMetadata = { general: {}, coverage: {}, variable: {} };

interface SearchMetadataProps {
  datasetId: string;
  datasetAcronym: string;
  isOfflineDataset: boolean;
}

export default function SearchMetadata({
  datasetId,
  datasetAcronym,
  isOfflineDataset,
}: SearchMetadataProps) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const [metadata, setMetadata] = useState<IDatasetMetadata>(
    () => initialMetadata
  );

  useEffect(() => {
    setMetadata(initialMetadata);
    doMetadataUpdate(datasetId);
  }, [datasetId]);

  const doMetadataUpdate = async (name: string) => {
    setLoading(true);
    setError(false);
    try {
      const metadata = await Api.detail.searchDatasetDetail(name);

      const general: { [key: string]: any } = {};
      const coverage: { [key: string]: any } = {};
      const variable: { [key: string]: any } = {};

      Object.entries(metadata).forEach(([key, value]) => {
        const [prefix, ...rest] = key.split('_');
        const suffix = rest.join('_');

        if (prefix) {
          switch (prefix.toLowerCase()) {
            case 'general':
              general[suffix] = value;
              break;
            case 'coverage':
              coverage[suffix] = value;
              break;
            case 'variables':
              variable[suffix] = value;
              break;
          }
        }
      });

      setMetadata({ general, coverage, variable });
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.root}>
      <Loading loading={loading}></Loading>
      {error && <Empty />}

      {!error && (
        <Tabs
          defaultActiveKey='1'
          className={styles.flexTabs}
          items={[
            {
              label: 'General',
              key: '1',
              children: (
                <MetadataList
                  data={metadata.general}
                  datasetAcronym={datasetAcronym}
                  isOfflineDataset={isOfflineDataset}
                />
              ),
            },
            {
              label: 'Coverage',
              key: '2',
              children: (
                <MetadataList
                  data={metadata.coverage}
                  datasetAcronym={datasetAcronym}
                  isOfflineDataset={isOfflineDataset}
                />
              ),
            },
            {
              label: 'Variables',
              key: '3',
              children: (
                <MetadataList
                  data={metadata.variable}
                  datasetAcronym={datasetAcronym}
                  isOfflineDataset={isOfflineDataset}
                />
              ),
            },
          ]}
        />
      )}
    </div>
  );
}
